import(/* webpackMode: "eager" */ "/app/src/app/[locale]/services/layout.tsx");
